import { createContext, useContext } from 'react'
import { useStore } from 'zustand'
import type { WorkspaceStore, WorkspaceStoreInternalState } from './store'

export const WorkspaceStoreContext = createContext<WorkspaceStore | null>(null)

export function useWorkspaceStore<T>(selector: (state: WorkspaceStoreInternalState) => T): T {
  const store = useContext(WorkspaceStoreContext)
  if (!store) {
    throw new Error('useWorkspaceStore must be used within WorkspaceStoreProvider')
  }
  return useStore(store, selector)
}

export function useWorkspaceStoreApi(): WorkspaceStore {
  const store = useContext(WorkspaceStoreContext)
  if (!store) {
    throw new Error('useWorkspaceStoreApi must be used within WorkspaceStoreProvider')
  }
  return store
}
